module.exports = __webpack_public_path__ + "assets/86e3529d5bb377e329ce1957f166e2a6.mp3";